<template>
  <div id="ContactForm" class="page-content">
    <div class="flex">
      <form id="contact-form">
        <div class="form-text">
          <p class="title" >SCRIVICI per informazioni, dubbi, domande o suggerimenti</p>
        </div>
        <div class="form-text">
          <label for="email">Inserisci la tua e-mail: (facoltativo)</label>
          <input
            class="input-text"
            id="email"
            type="email"
            name="email"
            v-model="form.email"
          />
        </div>
        <div>
          <div>
            <label id="message-label" for="message">MESSAGGIO</label>
          </div>
          <textarea
            class="input-text"
            id="message"
            type="text"
            name="message"
            v-model="form.message"
            v-on:keyup.enter="sendForm"
            rows="8" cols="100"
          />
        </div>
        <game-button @clicked="sendForm()" :disabled="clicked || form.message.length == 0">INVIA</game-button>
      </form>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import GameButton from "./Button";
import { notify } from "@/event-bus";

export default {
  name: "ContactForm",
  components: {
    GameButton,
  },
  data() {
    return {
      form: {
        message: "",
        email: ""
      },
      clicked: false
    };
  },
  computed: {
    ...mapGetters({
      user: "user/user"
    })
  },
  methods: {
    sendForm() {
      if (this.form.email && !this.validEmail(this.form.email)) {
        notify("e-mail non valida", "ERROR");
        return
      }
      this.clicked = true;
      this.$store.dispatch("contacts/sendMessage", this.form)
      .then(() => {
        this.form.message = "";
        this.form.email = "";
        this.clicked = false;
      });
    },
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  }
};
</script>
<style scoped>
.form-text {
  margin: 5em;
}
#email {
  width: 60%;
}
#contact-form {
  background-color: rgb(119, 212, 208);
  margin-top: 2em;
  padding: 10px;
  margin-bottom: 1em;
  border: solid 3px darkslategrey;
  width: 80%;
}
textarea {
  resize: none;
  width: 80%;
}
#message-label {
  font-size: 18px;
  font-weight: bolder;
}
.title {
  font-size: 26px;
  font-weight: bolder;
}

@media all and (max-width: 950px), (max-height: 800px){
  .title {
    font-size: 22px;
  }

  .form-text {
    display: block !important;
    margin: 2em;
  }
  #email {
    width: 100%;
  }
}

@media all and (max-width: 450px), (max-height: 400px) {
  .title {
    font-size: 18px;
  }
  .form-text {
    display: block !important;
    margin: 1em;
  }
  #email {
    width: 100%;
  }
  .form-button {
    padding: 1em;
    margin: 0.5em;
  }
  #contact-form {
    margin-top: .5em;
    padding: 10px;
    margin-bottom: 4em;
  }
}

</style>
